import { Box, Text } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import ThreadHeader from './ThreadHeader';
import ThreadsHistory from './ThreadsHistory';
import MessageComponse from './ThreadCompose';

const ThreadsArea = () => {
  //     <Box>
  //     <Box>
  //       <ThreadHeader />
  //       <Box>
  //         <Thread messages={messages} />
  //       </Box>
  //       <MessageComponse
  //         viewAccounts={viewAccounts}
  //         fetchMessages={fetchMessages}
  //       />
  //     </Box>
  //   </Box>
  return (
    <Box>
      <Box>
        <ThreadHeader />
        <Box>
          <ThreadsHistory />
          <MessageComponse />
        </Box>
      </Box>
    </Box>
  );
};

export default ThreadsArea;
